import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import axios from 'axios';
import HeaderLogin from './main/nav-login/HeaderLogin';
import Footer from './main/nav/Footer';
import GrafikJurnal from './user/GrafikJurnal';
import { Link } from 'react-router-dom';
import bgImage from '../assets/img/bg.jpg';

const publicationMeta = [

];

export default function Home() {
    const grafik = useRef(null);
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [dataAll, setDataAll] = useState({});
    const [publicationTypes, setPublicationTypes] = useState([]);
    const [keyword, setKeyword] = useState('');
    const [loading, setLoading] = useState(true);

    const gotoGrafik = () => {
        grafik.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const publicationItems = publicationTypes.length
        ? publicationTypes.map((item) => ({
            key: item.key,
            label: item.nama,
            path: `/public/publikasi/${item.key}`,
            icon: item.nama
                .split(' ')
                .map((word) => word.charAt(0))
                .join('')
                .slice(0, 2)
                .toUpperCase(),
            value: item.total,
        }))
        : publicationMeta.map((item) => ({
            ...item,
            value: dataAll[item.key],
        }));

    const totalPublikasi = Number(dataAll.total || 0) || publicationItems.reduce((total, item) => total + Number(item.value || 0), 0);

    const fetchDataAll = async () => {
        const { data } = await axios.get('/dataall-get');
        setDataAll(data);
        setPublicationTypes(Array.isArray(data?.jenis) ? data.jenis : []);
    };

    const fetchData = async () => {
        const { data } = await axios.get('/data-get');
        if (data) {
            setData(data);
        }
    };

    const submitSearch = (event) => {
        event.preventDefault();
        const param = keyword.trim();

        if (param) {
            navigate('/cari', { state: { param } });
        }
    };

    useEffect(() => {
        const loadData = async () => {
            try {
                await Promise.all([fetchData(), fetchDataAll()]);
            } catch (error) {
                console.error("Gagal mengambil data home:", error);
            } finally {
                setLoading(false);
            }
        };
        loadData();
    }, []);

    return (
        <div className="min-h-screen bg-white text-brand-navy">
            <HeaderLogin data={data} grafik={gotoGrafik} />

            <main>
                <section className="relative grid min-h-[565px] grid-cols-1 overflow-hidden lg:grid-cols-2 ">
                    <div
                        className="relative min-h-[320px] bg-cover bg-center lg:min-h-[565px]"
                        style={{ backgroundImage: `linear-gradient(rgba(10,10,10,.3), rgba(10,10,10,.3)), url(${bgImage})` }}
                    />

                    <div className="flex min-h-[420px] items-center bg-brand-navy px-6 py-16 text-white sm:px-10 lg:min-h-[565px] lg:px-24 ">
                        <div className="w-full max-w-xl ">
                            <h1 className="font-display text-4xl font-extrabold tracking-normal sm:text-5xl">Cari Data</h1>
                            <p className="mt-4 max-w-lg text-lg leading-8 text-slate-300">
                                Cari data publikasi database dengan memasukkan keywords pada kolom berikut.
                            </p>
                            <form onSubmit={submitSearch} className="mt-8 ">
                                <label htmlFor="home-search" className="sr-only">Tulis Keywords di sini</label>
                                <div className="flex flex-col gap-3 sm:flex-row ">
                                    <input
                                        id="home-search"
                                        value={keyword}
                                        onChange={(event) => setKeyword(event.target.value)}
                                        placeholder="Tulis Keywords di sini ..."
                                        className="h-12 min-w-0 flex-1 rounded-lg border border-white/60 bg-white/10 px-4 text-base text-white outline-none placeholder:text-white/70 focus:border-brand-gold focus:ring-2 focus:ring-brand-gold/30"
                                    />
                                    <button
                                        type="submit"
                                        className="h-12 rounded-lg bg-brand-gold px-6 text-sm font-extrabold text-brand-navy transition hover:bg-white focus:outline-none focus:ring-2 focus:ring-brand-gold focus:ring-offset-2 focus:ring-offset-brand-navy"
                                    >
                                        Cari
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>

                </section>

                <section id="content-home" className="mx-auto grid max-w-6xl gap-8 px-4 py-12 sm:px-6 lg:grid-cols-[0.95fr_1.25fr] lg:py-16">
                    <div className="lg:pr-6">
                        <span className="text-xs font-extrabold uppercase tracking-normal text-brand-green">RPU Universitas Samudra</span>
                        <h2 className="mt-3 font-display text-3xl font-extrabold leading-tight text-brand-navy sm:text-4xl">
                            Publikasi akademik
                        </h2>
                        <p className="mt-4 text-base leading-8 text-slate-600">
                            Telusuri karya dosen dan sivitas akademika berdasarkan jenis publikasi tren.
                        </p>

                        <div className="mt-6 flex flex-col gap-5 rounded-lg border border-slate-200 bg-brand-soft p-5 sm:flex-row sm:items-center sm:justify-between">
                            <div>
                                <span className="block text-sm font-bold text-slate-500">Total Data</span>
                                {loading ? (
                                    <div className="mt-2 h-9 w-20 animate-pulse rounded-md bg-slate-200"></div>
                                ) : (
                                    <strong className="mt-1 block text-4xl font-extrabold leading-none text-brand-navy">{totalPublikasi}</strong>
                                )}
                            </div>
                            <Link
                                to="/repository"
                                className="inline-flex h-12 items-center justify-center rounded-lg bg-brand-navy px-5 text-sm font-bold text-white transition hover:bg-brand-green"
                            >
                                Jelajahi Repository
                            </Link>
                        </div>

                        <div className="mt-6 border-l-4 border-brand-gold pl-4 text-sm leading-7 text-slate-600">
                            Data disajikan untuk membantu pemetaan produktivitas riset, dokumentasi karya, dan akses publik terhadap publikasi Unsam.
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
                        {loading ? (
                            Array.from({ length: 6 }).map((_, index) => (
                                <div key={index} className="min-h-[138px] animate-pulse rounded-lg border border-slate-200 bg-slate-100/50 px-4 py-3 shadow-soft">
                                    <div className="mt-4 h-4 w-3/4 rounded bg-slate-200"></div>
                                    <div className="mt-4 h-8 w-12 rounded bg-slate-300"></div>
                                    <div className="mt-2 h-3 w-8 rounded bg-slate-200"></div>
                                </div>
                            ))
                        ) : (
                            publicationItems.map((item) => (
                                <Link
                                    to={item.path}
                                    className="group min-h-[138px] rounded-lg border border-slate-200 bg-white px-4 py-3 text-brand-navy shadow-soft transition hover:-translate-y-1 hover:border-brand-green"
                                    key={item.label}
                                >
                                    <span className="mt-4 block min-h-10 text-sm font-bold text-slate-600">{item.label}</span>
                                    <span className="mt-2 inline-block text-3xl font-extrabold leading-none">{item.value || 0}</span>
                                    <span className="ml-1 text-xs font-bold text-slate-500">Data</span>
                                </Link>
                            ))
                        )}
                    </div>

                    <div ref={grafik} className="lg:col-span-2">
                        <GrafikJurnal auth={false} />
                    </div>
                </section>
            </main>

            <div className="bg-brand-navy text-white">
                <Footer />
            </div>
        </div>
    );
}
